import React from "react";
function Index() {
  return (
    <React.Fragment>
      <div className="ourService">
        <div className="container">
          <div className="row mx-auto">
            <div className="col-md-9 mx-auto">
              <div
                className="title"
                data-aos="fade-down"
                data-aos-duration="1500"
              >
                <div className="row">
                  <div className="col-md-8 col-lg-6">
                    <h1>Our Services</h1>
                  </div>
                </div>
              </div>
              <div
                className="serviceCards"
                data-aos="zoom-out"
                data-aos-duration="1500"
              >
                <div className="row">
                  <div className="col-md-6 col-lg-4 service">
                    <h1>Specialization</h1>
                    <p>
                      We are specialized in commercial and residential
                      properties. Having top knowledge of market trends, our
                      consultants have everything for you, from residential
                      plots, apartments and houses to commercial plazas, offices
                      and business centers.
                    </p>
                  </div>
                  <div className="col-md-6 col-lg-4 service">
                    <h1>Reputation</h1>
                    <p>
                      Ali Saqlain Real Estate has an excellent reputation in the
                      market and in the communities we serve. We are active,
                      involved and connected. Our team lives in the communities
                      we serve, giving us an additional motivation in making
                      transactions happen.
                    </p>
                  </div>
                  <div className="col-md-6 col-lg-4 service">
                    <h1>Authorization</h1>
                    <p>
                      Being the very first authorized dealer for Bahria Town,
                      Ali Saqlain Real Estate & Builders has strong footholds of
                      credibility in the real estate market.We believe in doing
                      business in an authorized way.
                    </p>
                  </div>
                  <div className="col-md-6 col-lg-4 service">
                    <h1>Responsibility</h1>
                    <p>
                      Since we are known for being responsible, we take huge
                      care of your investments. In order to safeguard investors’
                      interest, we provide open assistance of projects on
                      pricing, purchasing and selling.
                    </p>
                  </div>
                  <div className="col-md-6 col-lg-4 service">
                    <h1>Knowledge</h1>
                    <p>
                      Real estate industry keeps on fluctuating throughout the
                      year. Our market research staff fulfills procedural
                      requirements to gather updated market knowledge, which we
                      transfer to our clients helping them take profitable
                      investment decisions.
                    </p>
                  </div>
                  <div className="col-md-6 col-lg-4 service">
                    <h1>Professionalism</h1>
                    <p>
                      Our real estate consultants specifically come from finance
                      and sales background and they do everything to demonstrate
                      the highest level of professionalism. They remain informed
                      of the demand, availability and value of residential and
                      commercial plots and houses.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Index;
